type QueryValue = string | number | boolean | string[] | undefined;

export const buildQueryParams = <T extends object>(filters?: T): string => {
  if (!filters) return '';

  const params = new URLSearchParams();

  Object.entries(filters as Record<string, QueryValue>).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      if (Array.isArray(value)) {
        value.forEach(v => params.append(key, String(v)));
      } else {
        params.set(key, String(value));
      }
    }
  });

  return params.toString();
};

export const getFilenameFromHeader = (contentDisposition: string | null): string => {
  if (!contentDisposition) {
    return 'download.xlsx';
  }

  const utf8Match = contentDisposition.match(/filename\*=UTF-8''(.+)/i);
  if (utf8Match && utf8Match[1]) {
    return decodeURIComponent(utf8Match[1]);
  }

  const standardMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
  if (standardMatch && standardMatch[1]) {
    return standardMatch[1].replace(/["']/g, '');
  }

  return 'download.xlsx';
};
